import React, { useState } from 'react';

import { captureException } from 'utils/errors';
import SwitchInput from 'components/SwitchInput';
import http from 'utils/http';

function VipSwitch({ customer, onChange }) {
  const [loading, setLoading] = useState(false);

  function handleChange(value) {
    setLoading(true);
    return http.patch(`/v1/organizations/{{organizationId}}/customers/${customer.id}/`, { is_vip: value })
      .then((res) => {
        const data = res?.data?.data ?? res?.data ?? res;
        onChange(data?.is_vip ?? value);
      })
      .catch(captureException)
      .finally(() => setLoading(false));
  }

  return (
    <SwitchInput
      label="VIP"
      loading={loading}
      checked={customer?.is_vip ?? false}
      unCheckedChildren={null}
      onChange={handleChange}
      description="Mark this customer as a VIP. VIP customers can be visually tagged across the platform."
    />
  );
}

export default VipSwitch;
